import { render, staticRenderFns } from "./clients.vue?vue&type=template&id=72ce13a3"
import script from "./clients.vue?vue&type=script&lang=ts"
export * from "./clients.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports